<template>
  <div>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="get_upcomingbooking.record"
      border
    >
      <el-table-column
        label="Sr. No"
        type="index"
        :index="indexMethod"
        width="80px"
      ></el-table-column>
      <el-table-column label="Name" min-width="160px" prop="name">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.userId.firstname + " " + row.userId.lastname
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Phone No." prop="mobile" min-width="160px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.userId.mobile
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Email" prop="email" min-width="160px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.userId.email
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Session Id" prop="id" min-width="160px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{ row._id }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column
        label="Session Type"
        prop="sessiontype"
        min-width="160px"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.session.toUpperCase()
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        label="Session Date"
        prop="sessiontype"
        min-width="160px"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">
                {{
                  new Date(row.date).toLocaleDateString("en-IN", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                }}</span
              >
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        label="Session Time"
        prop="sessiontype"
        min-width="160px"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{ row.time }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        min-width="160px"
        v-slot="{ row }"
        prop="status"
      >
        {{ row.status }}
      </el-table-column>
      <el-table-column
        label="Action"
        min-width="160px"
        v-slot="{ row }"
        prop="status"
      >
        <base-button
          type="primary"
          class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
          @click="handleStatus('Complete', row._id)"
          v-if="row.status === 'Upcoming'"
        >
          Complete
          <!-- 65aa84be3e4ccb078cbf6304 -->
        </base-button>
      </el-table-column>
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import projects from "../../../layouts/components/projects";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      projects,
      upcomingbooking: [],
      currentPage: 1,
      perPage: 10,
      total_row: 1,
    };
  },
  methods: {
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async init() {
      const payload = {
        _id: this.get_volunteerbyuserId[0]._id,
        limit: 10,
        offset: this.currentPage - 1,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("respitecare/get_upcomingbooking", payload);
        this.total_row = this.get_upcomingbooking.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async handleStatus(status, id) {
      let payload = {
        _id: id,
        status: "Completed",
        completedOn: new Date(),
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("respitecare/editbooking", payload);
        await this.$store.dispatch("respitecare/get_allbookingcounts", {
          volunteerId: this.get_volunteerbyuserId[0]._id,
        });
        await this.init();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_upcomingbooking: "get_upcomingbooking",
      get_volunteerbyuserId: "get_volunteerbyuserId",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
